import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Initialize AWS Amplify for Cognito authentication
import { initializeAmplify } from '@/lib/amplifyConfig';
initializeAmplify();

// Initialize theme
import { useThemeStore } from '@/stores/themeStore';
useThemeStore.getState().initTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

